<div class="position-relative">
  <ng-container *ngIf="!mobToggle">
    <div class="name-handle">
      <p class="f-14">
        {{
          active_project_store?.Project_Name
            ? active_project_store?.Project_Name + ' - ' + (unitForm?.controls['lot_name'].value || selected_eoi?.lot_name)
            : selected_eoi?.project_name
              ? selected_eoi?.project_name + ' - ' + (unitForm?.controls['lot_name'].value || selected_eoi?.lot_name)
              : this.selected_eoi?.projectid + ' - ' + (unitForm?.controls['lot_name'].value || selected_eoi?.lot_name)
        }}
      </p>
    </div>
  </ng-container>
  <div [formGroup]="unitForm">
    <div class="popup-box-top mb-3">
      <div class="row">
        <div class="col-sm-3">
          <p class="f-12 mb-2">Project</p>
          <ng-select
            [items]="lmService?.ProjectList"
            formControlName="projectid"
            bindLabel="Project_Name"
            bindValue="_id"
            [searchable]="true"
            placeholder="Select"
            [ngClass]="{ '_input-error': unitForm.controls['projectid'].hasError('required') }">
          </ng-select>
        </div>
        <div class="col-sm-3">
          <p class="f-12 mb-2">Lot</p>
          <input
            type="text"
            formControlName="lot_name"
            [ngClass]="{ '_input-error': unitForm.controls['lot_name'].hasError('required') }"
            (input)="changeLotName()" />
        </div>
        <div class="col-sm-3">
          <p class="f-12 mb-2">Status Reason</p>
          <ng-select
            [items]="unit_status"
            formControlName="status_reason"
            bindLabel="tag_name"
            bindValue="tag_name"
            [searchable]="true"
            placeholder="Select"
            [ngClass]="{ '_input-error': unitForm.controls['status_reason'].hasError('required') }">
          </ng-select>
        </div>
        <div class="col-sm-3 text-right mt-3">
          <button class="mr-2 _outline-btn bg-white" (click)="saveUnit('onlyCreate')">Save</button>
          <button class="_primary-btn" (click)="saveUnit('create')">Save & Close</button>
        </div>
      </div>
    </div>
    <div class="popup-box mb-3">
      <div class="row">
        <div class="col-sm-3">
          <p class="f-12 mb-2">Lot Price</p>
          <app-price-input [field_value]="unitForm.controls['lot_price'].value" (onUpdate)="updatePrice($event, 'lot_price')"> </app-price-input>
        </div>
        <div class="col-sm-3">
          <p class="f-12 mb-2">Car Park Price</p>
          <ng-container *ngIf="disabled_carpark_price; else noDisabled">
            <input type="text" value="{{ disabled_carpark_price }}" disabled />
          </ng-container>
          <ng-template #noDisabled>
            <app-price-input [field_value]="unitForm.controls['car_park_price'].value" (onUpdate)="updatePrice($event, 'car_park_price')">
            </app-price-input>
          </ng-template>
        </div>
        <div class="col-sm-3">
          <p class="f-12 mb-2">Storage Price</p>
          <app-price-input [field_value]="unitForm.controls['storage_price'].value" (onUpdate)="updatePrice($event, 'storage_price')">
          </app-price-input>
        </div>
        <div class="col-sm-3">
          <p class="f-12 mb-2">Total</p>
          <app-price-input [field_value]="unitForm.controls['total'].value" (onUpdate)="updatePrice($event, 'total')"> </app-price-input>
        </div>
      </div>
    </div>
    <div class="popup-box mb-3">
      <div class="row">
        <div class="col-sm-2">
          <p class="f-12 mb-2">Bed</p>
          <input type="number" formControlName="bed" [ngClass]="{ '_input-error': unitForm.controls['bed'].hasError('required') }" />
        </div>
        <div class="col-sm-2">
          <p class="f-12 mb-2">Bath</p>
          <input type="number" formControlName="bath" [ngClass]="{ '_input-error': unitForm.controls['bath'].hasError('required') }" />
        </div>
        <div class="col-sm-2">
          <p class="f-12 mb-2">Car</p>
          <input type="number" formControlName="space" />
        </div>
        <div class="col-sm-2">
          <p class="f-12 mb-2">Storage</p>
          <input type="number" formControlName="storage" />
        </div>
        <div class="col-sm-2">
          <p class="f-12 mb-2">Study</p>
          <input type="text" formControlName="study" />
        </div>
        <div class="col-sm-2">
          <p class="f-12 mb-2">MPR</p>
          <input type="text" formControlName="mpr" />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-2">
          <p class="f-12 mb-2">Car No. Included</p>
          <ng-select
            class="ng-site-input"
            formControlName="carpark_included"
            [items]="car_park_list"
            [multiple]="true"
            bindLabel="carpark_lot"
            bindValue="carpark_lot"
            [searchable]="true"
            placeholder="Select"
            [clearable]="false"
            (change)="changeCarStorage($event, 'car_park_include')">
            <ng-template ng-label-tmp let-item="item">
              <div class="d-flex align-items-center cursor-pointer px-1">
                <i class="pi pi-times-circle cursor-pointer" (click)="clear(item?.carpark_lot, 'carpark_included'); $event.stopPropagation()"></i>
                <p class="ml-2 ng-value-label">{{ item.carpark_lot }}</p>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span>{{ item.carpark_lot }}</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-sm-2">
          <p class="f-12 mb-2">Car No.</p>
          <ng-select
            class="ng-site-input"
            formControlName="carpark_added"
            [items]="car_park_list"
            [multiple]="true"
            bindLabel="carpark_lot"
            bindValue="carpark_lot"
            [searchable]="true"
            placeholder="Select"
            [clearable]="false"
            (change)="changeCarStorage($event, 'car_park')">
            <ng-template ng-label-tmp let-item="item">
              <div class="d-flex align-items-center cursor-pointer px-1">
                <i class="pi pi-times-circle cursor-pointer" (click)="clear(item?.carpark_lot, 'carpark_added'); $event.stopPropagation()"></i>
                <p class="ml-2 ng-value-label">{{ item.carpark_lot }}</p>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span>{{ item.carpark_lot }}</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-sm-2">
          <p class="f-12 mb-2">Storage Included</p>
          <ng-select
            class="ng-site-input"
            formControlName="storage_included"
            [items]="storage_list"
            [multiple]="true"
            bindLabel="storage_no"
            bindValue="storage_no"
            [searchable]="true"
            placeholder="Select"
            [clearable]="false"
            (change)="changeCarStorage($event, 'storage_include')">
            <ng-template ng-label-tmp let-item="item">
              <div class="d-flex align-items-center cursor-pointer px-1">
                <i class="pi pi-times-circle cursor-pointer" (click)="clear(item?.storage_no, 'storage_included'); $event.stopPropagation()"></i>
                <p class="ml-2 ng-value-label">{{ item.storage_no }}</p>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span>{{ item.storage_no }}</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-sm-2">
          <p class="f-12 mb-2">Storage</p>
          <ng-select
            class="ng-site-input"
            formControlName="storage_added"
            [items]="storage_list"
            [multiple]="true"
            bindLabel="storage_no"
            bindValue="storage_no"
            [searchable]="true"
            placeholder="Select"
            [clearable]="false"
            (change)="changeCarStorage($event, 'storage')">
            <ng-template ng-label-tmp let-item="item">
              <div class="d-flex align-items-center cursor-pointer px-1">
                <i class="pi pi-times-circle cursor-pointer" (click)="clear(item?.storage_no, 'storage_added'); $event.stopPropagation()"></i>
                <p class="ml-2 ng-value-label">{{ item.storage_no }}</p>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span>{{ item.storage_no }}</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-sm-2">
          <p class="f-12 mb-2">Type</p>
          <ng-select [items]="unit_type" formControlName="type" bindLabel="name" bindValue="name" [searchable]="true" placeholder="Select">
          </ng-select>
        </div>
        <div class="col-sm-2">
          <p class="f-12 mb-2">Level</p>
          <ng-select [items]="unit_level" formControlName="level" bindLabel="tag_name" bindValue="tag_name" [searchable]="true" placeholder="Select">
          </ng-select>
        </div>
      </div>
    </div>
    <div class="popup-box mb-3">
      <div class="row">
        <div class="col-sm-3">
          <p class="f-12 mb-2">Internal Area</p>
          <app-price-input
            [field_value]="unitForm.controls['internal_area'].value"
            (onUpdate)="calculateArea($event, 'internal_area')"
            [isIconVisible]="false">
          </app-price-input>
        </div>
        <div class="col-sm-3">
          <p class="f-12 mb-2">External Area</p>
          <app-price-input
            [field_value]="unitForm.controls['external_area'].value"
            (onUpdate)="calculateArea($event, 'external_area')"
            [isIconVisible]="false">
          </app-price-input>
        </div>
        <div class="col-sm-3">
          <p class="f-12 mb-2">Total Area</p>
          <app-price-input
            [field_value]="unitForm.controls['total_area'].value"
            (onUpdate)="calculateArea($event, 'total_area')"
            [isIconVisible]="false">
          </app-price-input>
        </div>
        <div class="col-sm-3">
          <p class="f-12 mb-2">Internal Price M2</p>
          <app-price-input [field_value]="unitForm.controls['price_m2'].value" (onUpdate)="updatePrice($event, 'price_m2')"> </app-price-input>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-3">
          <p class="f-12 mb-2">Aspect</p>
          <input type="text" formControlName="aspect" />
        </div>
        <div class="col-sm-3">
          <p class="f-12 mb-2">Orientation</p>
          <input type="text" formControlName="orientation" />
        </div>
        <div class="col-sm-3">
          <p class="f-12 mb-2">Current Allocation</p>
          <input type="text" formControlName="current_allocation" />
        </div>
        <div class="col-sm-3">
          <p class="f-12 mb-2 non-ypm-spacer" aria-hidden="true">&nbsp;</p>
          <div class="non-ypm-check">
            <label class="checkbox style-d">
              <input type="checkbox" formControlName="non_ypm_sale" />
              <div class="checkbox__checkmark"></div>
              <div class="checkbox__body f-12">Non YPM Sale</div>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 text-right mt-3">
      <button class="mr-2 _outline-btn bg-white" (click)="saveUnit('onlyCreate')">Save</button>
      <button class="_primary-btn" (click)="saveUnit('create')">Save & Close</button>
    </div>
  </div>
  <ng-container *ngFlag="'horizon'">
    <app-horizon-lot-engagement [unitId]="selected_eoi?._id"></app-horizon-lot-engagement>
  </ng-container>
</div>
